import React, { useEffect, useState } from "react";
import { getToken, getCustomerCode, getMobile, getVoucherCode, clearTokens, getEmail, getName } from "../services/tokenService";
import { fetchClaimedVoucher, getVoucher, unityFulfilmentToken, unityVoucherAssign } from "../api/authApi";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";

const Voucher = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [voucher, setVoucher] = useState(null);
  const [viewCode, setViewCode] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const [claimed, setClaimed] = useState(false);
  const [cardData, setCardData] = useState({
    cardPin: "",
    cardNumber: "",
    validity: ""
  })
  const [copied, setCopied] = useState({
    number: false,
    pin: false
  });
  const [openUsage, setOpenUsage] = useState(false);
  const [voucherAlreadyUsed, setVoucherAlreadyUsed] = useState(false);
  const [voucherExpired, setVoucherExpired] = useState(false);
  const [recordNotFound, setRecordNotFound] = useState(false);
  const mobile = getMobile();
  const voucherCode = getVoucherCode();
  const customerCode = getCustomerCode();
  const email = getEmail();
  const name = getName();

  useEffect(() => {
    document.body.classList.add("primary_bg", "fit_box");

    return () => {
      document.body.classList.remove("primary_bg", "fit_box");
    };
  }, []);

  useEffect(() => {
    if (viewCode) {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    }
  }, [viewCode]);

  const handleLogout = () => {
    clearTokens();
    navigate(`/login?voucherCode=${voucherCode}`);
  };

  const claimedVoucherDetails = async () => {
    const token = await unityFulfilmentToken()
    const response = await fetchClaimedVoucher(token?.message?.data?.access_token, voucherCode)

    if (response?.message === "Order saved successfully.") {
      setCardData((prev) => ({
        ...prev,
        cardNumber: response?.data?.[0]?.order_response?.[0]?.cards?.[0]?.cardNumber,
        cardPin: response?.data?.[0]?.order_response?.[0]?.cards?.[0]?.cardPin,
        validity: response?.data?.[0]?.order_response?.[0]?.cards?.[0]?.validity
      }))
    }
  }

  useEffect(() => {
    const fetchVoucher = async () => {
      try {
        const token = getToken();
        const res = await getVoucher(token, mobile, voucherCode);
        if (res && res.data?.length > 0) {
          setVoucher(res?.data?.[0]);
          if (res?.data?.[0]?.voucherUsed) {
            setVoucherAlreadyUsed(true);
            await claimedVoucherDetails()
          } else if (moment.utc().isAfter(moment.utc(res?.data?.[0]?.expiryDate))) {
            setVoucherExpired(true);
          }
        } else {
          setRecordNotFound(true)
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchVoucher();
  }, []);

  const claimVoucher = async () => {
    setShowPopup(false);
    const status = await assignVoucher()
    if (status) {
      setClaimed(true)
    }
  };

  const assignVoucher = async (data) => {

    try {
      setLoading(true)
      const token = await unityFulfilmentToken()
      const body = {
        denomination: data ? data?.earnedValue : voucher?.earnedValue,
        quantity: 1,
        sender_name: "Clavax Technologies",
        receiver_email: email,
        user_code: customerCode,
        receiver_mobile: mobile,
        receiver_name: name,
        voucher_template_code: data ? data?.voucherTemplateCode : voucher?.voucherTemplateCode,
        voucher_code: data ? data?.voucherCode : voucher?.voucherCode
      }
      const response = await unityVoucherAssign(token?.message?.data?.access_token, body)
      if (response?.message === "Voucher Assigned Successfully") {
        setCardData((prev) => ({
          ...prev,
          cardNumber: response?.data?.cards?.[0]?.card_number,
          cardPin: response?.data?.cards?.[0]?.card_pin,
          validity: response?.data?.cards?.[0]?.validity
        }))
        return true
      } else return false
    } catch (err) { }
    finally {
      setLoading(false)
    }

  }

  const copyCode = (value, name) => {
    navigator.clipboard.writeText(value);

    setCopied((prev) => ({
      ...prev,
      [name]: true
    }))

    setTimeout(() => {
      setCopied(false);
    }, 1500);
  };

  if (loading) {
    return (
      <div className="primary_bg fit_box loader-center">
        <div className="spinner"></div>
      </div>
    );
  }

  const logoutBtn = () => {
    return (
      <div className="logo_inner">
        <div className="logo_inner_left">
          <img src="/img/unity_bank_logo.svg" alt="Unity Bank Logo" />
        </div>
        <div className="logo_inner_right">
          {<button onClick={handleLogout}>
            <img src='https://cdn-icons-png.flaticon.com/512/4043/4043198.png' /> Logout
          </button>}
        </div>
      </div>
    )
  }

  if (claimed) {
    return (
      <div className="card">
        {logoutBtn()}
        <div class="check-wrap">
          <div class="voucher_text">
            {/* <img src="img/win_voucher.svg" alt="win voucher" /> */}
            {/* <h4 class="worth">Worth <span>₹{voucher?.earnedValue}</span></h4> */}
            <h2>Congratulations! You have successfully claimed your ₹{voucher?.earnedValue} Amazon voucher. Enjoy and redeem it on Amazon.</h2>
          </div>
          <img src="img/success_large.svg" alt="success" />
        </div>



        <div className="voucher_info_box">
          {cardData?.cardNumber && <div className="voucher_info_box_inner">
            <div className="voucher_info_box_inner_top">Card</div>

            <div className="voucher_info_box_inner_bottom copy">
              <span className="voucher-code">{cardData?.cardNumber}</span>
              <a
                className="copy-btn"
                onClick={() => copyCode(cardData?.cardNumber, "number")}
              >
                {copied.number ? "Copied" : "Copy"}
              </a>
            </div>
          </div>}

          {cardData?.cardPin && <div className="voucher_info_box_inner">
            <div className="voucher_info_box_inner_top">PIN</div>

            <div className="voucher_info_box_inner_bottom copy">
              <span className="voucher-code">{cardData?.cardPin}</span>
              <a
                className="copy-btn"
                onClick={() => copyCode(cardData?.cardPin, "pin")}
              >
                {copied.pin ? "Copied" : "Copy"}
              </a>
            </div>
          </div>}

          <div className="voucher_info_box_inner">
            <div className="voucher_info_box_inner_full">
              <div className="voucher_info_box_inner_full_left">Valid</div>

              Till: {moment(cardData?.validity).format("DD/MM/YYYY")}
            </div>
          </div>
        </div>

        <div className={`voucher-usage ${openUsage ? "active" : ""}`}>
          <div
            className="voucher-header"
            onClick={() => setOpenUsage(!openUsage)}
          >
            <h4>How to use this voucher?</h4>

            <span
              className={`toggle-icon ${openUsage ? "rotate" : ""}`}
            >
              +
            </span>
          </div>
          <div
            className="voucher-content"
            style={{ display: openUsage ? "block" : "none" }}
          >
            <ol>
              <li>Go to “Your Account” section on Amazon.in</li>
              <li>Select “Add Gift Card to your balance”</li>
              <li>Enter voucher code and click Add gift card</li>
            </ol>
          </div>
        </div>

        <Link to="https://www.amazon.in/" target="_blank"
          className="confirm-btn yellow"
        >
          Redeem on Amazon
        </Link>
      </div >
    );
  }

  // ================= NORMAL PAGE =================

  return (
    <>
      {voucherAlreadyUsed ? <div className="card">

        {logoutBtn()}

        <div class="check-wrap">
          <div class="voucher_text">
            {/* <img src="img/win_voucher.svg" alt="win voucher" /> */}
            {/* <h4 class="worth">Worth <span>₹{voucher?.earnedValue}</span></h4> */}
          </div>
          <img src="img/success_large.svg" alt="success" />
        </div>

        <h2>
          This voucher is already claimed and remains ready to use. View the code to redeem it
        </h2>
        {(cardData?.cardNumber || cardData?.cardPin) &&
          <>
            <button className="" onClick={() => setViewCode(true)}>View Code</button>
            {
              viewCode ? <div className={`voucher_info_box ${viewCode ? "mt-10" : ""}`}>
                {cardData?.cardNumber && <div className="voucher_info_box_inner">
                  <div className="voucher_info_box_inner_top">Card</div>

                  <div className="voucher_info_box_inner_bottom copy">
                    <span className="voucher-code">{cardData?.cardNumber}</span>
                    <a
                      className="copy-btn"
                      onClick={() => copyCode(cardData?.cardNumber, "number")}
                    >
                      {copied.number ? "Copied" : "Copy"}
                    </a>
                  </div>
                </div>}

                {cardData?.cardPin && <div className="voucher_info_box_inner">
                  <div className="voucher_info_box_inner_top">PIN</div>

                  <div className="voucher_info_box_inner_bottom copy">
                    <span className="voucher-code">{cardData?.cardPin}</span>
                    <a
                      className="copy-btn"
                      onClick={() => copyCode(cardData?.cardPin, "pin")}
                    >
                      {copied.pin ? "Copied" : "Copy"}
                    </a>
                  </div>
                </div>}

                <div className="voucher_info_box_inner">
                  <div className="voucher_info_box_inner_full">
                    <div className="voucher_info_box_inner_full_left">Valid</div>

                    Till: {moment(cardData?.validity).format("DD/MM/YYYY")}
                  </div>
                </div>
              </div> : ""
            }
          </>
        }


      </div> : voucherExpired ? <div className="card">
        {logoutBtn()}

        <div className="check-wrap">
          <img src="img/Expiredvoucher.png" alt="expired voucher" />
        </div>

        <h2>
          This voucher expired on <span>{moment(voucher?.expiryDate).format("DD/MM/YYYY")}</span> and can no longer be claimed.
        </h2>

      </div> : recordNotFound ? <div className="card">

        {logoutBtn()}

        <div className="check-wrap">

          <img src="img/notFound.png" alt="expired voucher" />

        </div>

        <h5>
          The voucher code is invalid. Please contact the support team for assistance.
        </h5>

      </div> : <div className="card">

        {logoutBtn()}

        <div className="gift-card">
          <img src="/img/amazon.png" alt="Amazon Gift Card" />
        </div>

        <h2>Voucher Value</h2>

        <div className="input-box">
          <h3>₹ {voucher?.earnedValue}</h3>
        </div>

        <button onClick={() => setShowPopup(true)}>
          Claim Voucher
        </button>
      </div>}


      {/* ================= POPUP ================= */}

      {showPopup && (
        <div
          className="popup-overlay"
          onClick={() => setShowPopup(false)}
        >
          <div
            className="popup-card"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Claim Voucher?</h3>

            <p>Do you want to claim this voucher?</p>

            <div className="popup-buttons">

              <button
                className="popup-cancel-btn"
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>

              <button
                className="popup-confirm-btn"
                onClick={claimVoucher}
              >
                Yes, Claim
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Voucher;